<nb-card>
  <nb-card-body>
    <nb-tabset>
      <nb-tab tabTitle="Echipe" tabIcon="people-outline" responsive>
        <nb-card [nbSpinner]="isSpinnerActive" nbSpinnerStatus="warning">
          <nb-card-header>
            <b>Echipa Ascon</b>
            <button nbButton class="ml-2 mr-2" size="small" status="info" (click)="addTeam()"
                    *ngIf="user.canRegisterTeam" [disabled]="isOneLineInEditMode">
              <nb-icon class="action-icon text-white" icon="plus-circle-outline"></nb-icon>
              Echipa noua
            </button>
            <button nbButton class="ml-2 mr-2" size="small" status="info" (click)="showMovePortofolio()"
                    *ngIf="user.canRegisterTeam">
              <nb-icon class="action-icon text-white" icon="edit-outline"></nb-icon>
              Mutare portofoliu
            </button>
          </nb-card-header>
          <nb-card-body>
            <div *ngIf="isMovePortofolioActivated">
              <form class="form-validation" role="form" autocomplete="off"
                    [formGroup]="formGroupMovePortofolio">
                <b>Mutare portofoliu de la:</b>
                <ngx-autocomplete-input
                  [items]="usersForAutocomplete"
                  placeholder=" Mutare portofoliu de la:"
                  (itemSelected)="userFrom = $event.id">
                </ngx-autocomplete-input>
                <b>Mutare portofoliu la:</b>
                <ngx-autocomplete-input
                  [items]="usersForAutocomplete"
                  placeholder=" Mutare portofoliu la:"
                  (itemSelected)="userTo = $event.id">
                </ngx-autocomplete-input>
                <button nbButton class="ml-2 mr-2" size="small" status="info"
                        [disabled]="!canMovePortofolio()" (click)="movePortofolio()">
                  Muta
                </button>
                <button nbButton status="danger" size="small" (click)="dismiss()">Anuleaza</button>
                <p></p>
              </form>
            </div>

            <virtual-scroller *ngIf="formGroup" #scroll [useMarginInsteadOfTranslate]="true" [items]="teams" [stripedTable]="true"
                              [enableUnequalChildrenSizes]="true" [scrollAnimationTime]="0">
              <form class="form-validation" role="form" autocomplete="off" [formGroup]="formGroup">
                <table class="table table-striped">
                  <thead class="bg-white" #header>
                  <tr>
                    <th *ngFor="let column of columns" [ngClass]="column.class"
                        [attr.colspan]="column.colspan" (click)="sortTeams(column, false)">
                      {{column.name}}
                      <nb-icon *ngIf="column.order === 'asc'" class="action-icon text-black"
                               icon="arrow-downward-outline"></nb-icon>
                      <nb-icon *ngIf="column.order === 'desc'" class="action-icon text-black"
                               icon="arrow-upward-outline"></nb-icon>

                      <div *ngIf="column.hasFilter && column.hasChildren"
                           style="display: inline">
                        <nb-select class="col-12 mr-2 yes-no-selector" size="tiny"
                                   placeholder="Filtru" #mySelect
                                   (selectedChange)="column.filterFunction($event)">
                          <nb-option value="">Toate</nb-option>
                          <nb-option *ngFor="let option of column.filterOptionsKeys"
                                     [value]="option"
                                     [innerHtml]="column.filterOptions[option]"></nb-option>
                        </nb-select>
                      </div>

                      <div *ngIf="column.hasChildren" style="display: flex;">
                                                    <span *ngFor="let children of column.children"
                                                          [ngClass]="children.class">
                                                        {{children.name}}
                                                    </span>
                      </div>
                    </th>
                  </tr>

                  <tr>
                    <th *ngFor="let column of columns" [ngClass]="column.class"
                        [attr.colspan]="column.colspan">
                      <div *ngIf="column.hasChildren" style="display: flex;">
                                                    <span *ngFor="let children of column.children"
                                                          [ngClass]="children.class">
                                                        <div *ngIf="children.hasFilter">
                                                            <nb-select class="col-12 mr-2 yes-no-selector" size="tiny"
                                                                       placeholder="Filtru" #mySelect
                                                                       (selectedChange)="children.filterFunction($event)">
                                                                <nb-option value="">Toate</nb-option>
                                                                <nb-option
                                                                  *ngFor="let option of children.filterOptionsKeys"
                                                                  [value]="option"
                                                                  [innerHtml]="children.filterOptions[option]"></nb-option>
                                                            </nb-select>
                                                        </div>
                                                    </span>
                      </div>
                      <div *ngIf="!column.hasChildren">
                        <div *ngIf="column.hasFilter">
                          <nb-select class="col-12 mr-2 yes-no-selector" size="tiny"
                                     placeholder="Filtru" #mySelect
                                     (selectedChange)="column.filterFunction($event)">
                            <nb-option value="">Toate</nb-option>
                            <nb-option *ngFor="let option of column.filterOptionsKeys"
                                       [value]="option"
                                       [innerHtml]="column.filterOptions[option]"></nb-option>
                          </nb-select>
                        </div>
                      </div>
                    </th>
                  </tr>
                  </thead>

                  <tbody #container>
                  <tr *ngIf="showNewTeamForm">

                    <td class="orc-action">
                      <button nbButton class="ml-1 mr-1 mb-1" size="small" status="info"
                              [disabled]="!canSaveNewTeam()" (click)="saveTeam()"
                              *ngIf="showNewTeamForm">
                        <nb-icon class="action-icon text-black"
                                 icon="plus-circle-outline"></nb-icon>
                      </button>
                      <button nbButton class="ml-1" size="small" status="danger"
                              (click)="cancelNewTeam()">
                        <nb-icon class="action-icon text-black"
                                 icon="slash-outline"></nb-icon>
                      </button>
                    </td>
                    <td class="orc-amount">
                      <nb-select formControlName="departament" placeholder="Departament"
                                 class="orc-amount">
                        <nb-option value="CONTABILITATE">CONTABILITATE</nb-option>
                        <nb-option value="HR">HR</nb-option>
                        <nb-option value="IT">IT</nb-option>
                        <nb-option value="JURIDIC">JURIDIC</nb-option>
                        <nb-option value="MANAGEMENT">MANAGEMENT</nb-option>
                        <nb-option value="FORMARE PROFESIONALA">FORMARE PROFESIONALA</nb-option>
                        <nb-option value="FONDURI EU">FONDURI EU</nb-option>
                      </nb-select>
                    </td>
                    <td class="orc-date">
                      <input nbInput placeholder="Nume" type="text" formControlName="name"
                             class="col-12 institution-full-width">
                    </td>
                    <td class="orc-reg-number">
                      <ngx-autocomplete-input
                        [items]="usersForAutocomplete"
                        placeholder="Sef echipa"
                        (itemSelected)="leader = $event.id">
                      </ngx-autocomplete-input>
                    </td>
                    <td class="orc-administrators">
                    </td>
                    <td class="orc-phone">
                      <nb-select class="col-12 mr-2" formControlName="members"
                                 placeholder="Membri" multiple>
                        <nb-option *ngFor="let user of users" [value]="user.user_id">
                          {{ user.fullname }}
                        </nb-option>
                      </nb-select>
                    </td>



                  </tr>
                  <tr *ngFor="let team of scroll.viewPortItems" [ngStyle]="{'background-color': getDepartmentColor(team.departament)}">
                    <td class="orc-action">
                      <div
                        *ngIf="!team.isInEditMode && !showNewTeamForm && !isOneLineInEditMode">
                        <nb-icon class="action-icon text-info" icon="edit-outline"
                                 *ngIf="user.canUpdateTeam" (click)="editTeam(team)"></nb-icon>
                        <nb-icon class="action-icon text-danger" icon="trash-outline"
                                 *ngIf="user.canDeleteTeam" (click)="deleteTeam(team)"></nb-icon>
                      </div>
                      <div *ngIf="team.isInEditMode && !showNewTeamForm">
                        <button nbButton class="ml-1 mr-1 mb-1" size="small" status="info"
                                [disabled]="!canSaveNewTeam()" (click)="saveTeam(team)">
                          <nb-icon class="action-icon text-black"
                                   icon="plus-circle-outline"></nb-icon>
                        </button>
                        <button nbButton class="ml-1" size="small" status="danger"
                                (click)="cancelEditTeam(team)">
                          <nb-icon class="action-icon text-black"
                                   icon="slash-outline"></nb-icon>
                        </button>
                      </div>
                    </td>
                    <td class="orc-objective">
                      <div *ngIf="!team.isInEditMode">
                        <i>{{team.departament}}</i>

                      </div>
                      <div *ngIf="team.isInEditMode">
                        <nb-select formControlName="departament" placeholder="Departament">
                          <nb-option value="CONTABILITATE">CONTABILITATE</nb-option>
                          <nb-option value="HR">HR</nb-option>
                          <nb-option value="IT">IT</nb-option>
                          <nb-option value="JURIDIC">JURIDIC</nb-option>
                          <nb-option value="MANAGEMENT">MANAGEMENT</nb-option>
                          <nb-option value="FORMARE PROFESIONALA">FORMARE
                            PROFESIONALA</nb-option>
                          <nb-option value="FONDURI EU">FONDURI EU</nb-option>
                        </nb-select>
                      </div>
                    </td>
                    <td class="orc-client">
                      <div *ngIf="!team.isInEditMode">
                        {{ team.name }}
                      </div>
                      <div *ngIf="team.isInEditMode">
                        <input nbInput placeholder="Nume" type="text" formControlName="name"
                               class="col-12 institution-full-width">
                      </div>
                    </td>
                    <td class="orc-reg-number-orc">
                      <div *ngIf="!team.isInEditMode">
                        {{ team.leaderName }}
                      </div>
                      <div *ngIf="team.isInEditMode">
                        <ngx-autocomplete-input
                          [items]="usersForAutocomplete"
                          [initialValue]="team.lead"
                          placeholder="Sef echipa"
                          (itemSelected)="leader = $event.id">
                        </ngx-autocomplete-input>
                      </div>
                    </td>
                    <td class="orc-date">
                      <div *ngIf="!team.isInEditMode">
                        {{ team.members.length }}
                      </div>
                      <div *ngIf="team.isInEditMode">
                      </div>
                    </td>
                    <td class="orc-commission">
                      <div *ngIf="!team.isInEditMode">
                        {{ team.membersName }}
                      </div>
                      <div *ngIf="team.isInEditMode">
                        <nb-select class="col-12 mr-2" formControlName="members"
                                   placeholder="Membri" multiple>
                          <nb-option *ngFor="let user of users" [value]="user.user_id">
                            {{ user.fullname }}
                          </nb-option>
                        </nb-select>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </form>
            </virtual-scroller>
          </nb-card-body>
        </nb-card>
      </nb-tab>
      <nb-tab tabTitle="Organizare Echipe" tabIcon="grid-outline" responsive>
        <ng-container *ngFor="let department of getDepartments()">
          <nb-card>
            <nb-card-header>
              {{ department }}
            </nb-card-header>
            <nb-card-body>
              <div style="overflow-x: auto; max-width: 100%; white-space: nowrap;">
                <div style="max-height: 300px; overflow-y: auto;">
                  <table class="table table-striped mt-4">
                    <thead>
                    <tr>
                      <th *ngFor="let team of getTeamsByDepartment(department)">
                        {{ team.name }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let i of getArrayForTeamMembers(department)">
                      <td *ngFor="let team of getTeamsByDepartment(department)">
                                    <span *ngIf="team.members[i]?.user_id === team.lead; else normalMember"
                                          style="font-weight: bold;">
                                      {{ team.members[i]?.fullname || '' }}
                                    </span>
                        <ng-template #normalMember>
                          {{ team.members[i]?.fullname || '' }}
                        </ng-template>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </ng-container>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>
